import React, { useMemo } from 'react';
import './FirefliesLayer.css';

const Firefly = React.memo(({ x, y, delay }: { 
  x: number; 
  y: number;
  delay: number 
}) => (
  <div 
    className="firefly"
    style={{
      '--firefly-x': x,
      '--firefly-y': y,
      animationDelay: `${delay}s`
    } as React.CSSProperties}
  />
));

const FirefliesLayer = () => {
  const fireflies = useMemo(() => 
    Array.from({ length: 15 }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      delay: Math.random() * 8
    })),
  []);

  return (
    <div className="fireflies-layer">
      {fireflies.map(firefly => (
        <Firefly
          key={firefly.id}
          x={firefly.x}
          y={firefly.y}
          delay={firefly.delay}
        />
      ))}
    </div>
  );
};

export default React.memo(FirefliesLayer);
